import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsOverview = ({ company }) => {
  return (
    <div className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Benefits & Perks
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We invest in our people with comprehensive benefits designed for your success
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {company?.benefits?.map((benefit, index) => (
            <div 
              key={index}
              className="flex gap-4 p-6 bg-card rounded-xl border border-border hover:border-primary/50 transition-colors"
            >
              <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${benefit?.bgColor}`}>
                <Icon name={benefit?.icon} size={24} color={benefit?.iconColor} />
              </div>
              
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {benefit?.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BenefitsOverview;